import React from "react";
import { ClipLoader } from "react-spinners";

function Loader({ props }) {
  const override = {
    display: "block",
    margin: "0 auto",
  };
  return (
    <ClipLoader
      color={"white"}
      loading={true}
      cssOverride={override}
      size={20}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  );
}
export default Loader;
